import React from 'react'
import { View } from 'react-native'
import { useTheme } from '@ui-kitten/components/theme'
import { Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Product } from '@src/types'
import { getPriceDescriptorWithPromo } from '@src/screens/Marketplace/utils/utils'
import { useIsDarkMode } from '@src/config/theme'

interface PromoCardProps {
  product: Product
}

export const PromoCard = (props: PromoCardProps) => {
  const styles = useStyleSheet(themedStyle)
  const { product } = props
  const appliedPromo = product.appliedPromo
  const promoPriceDescriptor = getPriceDescriptorWithPromo(product, appliedPromo)
  const isDarkMode = useIsDarkMode()
  const theme = useTheme()
  const darkTextColor = isDarkMode ? theme['theme.tooltip.textPrimary'] : undefined

  if (!appliedPromo) {
    return null
  }

  const message = (
    <>
      You're saving{' '}
      <Text type="regular" style={[{ color: darkTextColor }]} bold>
        {promoPriceDescriptor.amountSaved} monthly
      </Text>{' '}
      with code{' '}
      <Text type="regular" style={[{ color: darkTextColor }]} bold>
        {appliedPromo.code}
      </Text>{' '}
      automatically applied at checkout.
    </>
  )

  return (
    <View style={styles.container}>
      <Text type="title-3" style={styles.title}>
        LIMITED TIME OFFER
      </Text>
      <Text type="regular" style={[{ color: darkTextColor }]}>
        {message}
      </Text>
    </View>
  )
}

const themedStyle = StyleService.create({
  container: {
    padding: 12,
    marginBottom: 28,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 16,
    borderWidth: 3,
    backgroundColor: 'theme.surface.base4',
    borderColor: 'theme.surface.baseYellow',
    elevation: 2, // For Android shadow
    shadowColor: 'theme.warning.medium', // For iOS shadow
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 1,
    shadowRadius: 10,
  },
  title: {
    color: 'theme.warning.darkest',
    marginBottom: 2,
  },
})
